import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Order, Reclamation } from "./order";
import { OrderService } from "./order.service";
import { ClientService } from "../../shared/client/client.service";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class OrderDetailsResolver {
    constructor(
        private orderService: OrderService,
        private clientService: ClientService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Reclamation | Order> {
        if(route.params['isRecla'] == 'true') {
            return this.orderService.getDetailsReclamation(this.clientService.currentClient$.getValue(), route.params['order']);
        } else {
            return this.orderService.getDetailsDemande(route.params['order']);
        }
        
    }

}
